import type { ReactNode } from 'react';
import { Pagination } from '@/shared/ui/Pagination';
import { QueryStatus } from '@/shared/ui/QueryStatus';

type Props = {
  title: string;
  isLoading: boolean;
  error: unknown;
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  children: ReactNode;
};

/** AdminLTE box with a loading / error line, a table slot and pagination (user detail sections). */
export const PagedBox = ({ title, isLoading, error, page, totalPages, onPageChange, children }: Props) => (
  <div className="box box-primary">
    <div className="box-header with-border">
      <h3 className="box-title">{title}</h3>
    </div>
    <div className="box-body no-padding" style={{ overflowX: 'auto' }}>
      <QueryStatus isLoading={isLoading} error={error} errorText="Ошибка загрузки данных" />
      {children}
    </div>
    <Pagination page={page} totalPages={totalPages} onChange={onPageChange} />
  </div>
);
